export default __webpack_public_path__ + "images/DynamicsGPSVG.svg";